import {createSelector} from "reselect";
import {getNavigationState} from "../root-selectors";
import {NavigationState} from "./types";
import {ConfirmationMessage} from "../../api/types";

export const getNavigationChallenge = createSelector(
    [getNavigationState],
    (state: NavigationState): ConfirmationMessage | null => state.challengeNavigation
)
